import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';

import store from'./store/index'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
    <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);



window.onscroll = () => {
  const topNav = document.querySelector(".topNav").scrollHeight;
  
 if(window.scrollY >= topNav){
   document.querySelector("nav").style.position = "fixed";
   document.querySelector("nav").style.top = 0;
 } else{
  document.querySelector("nav").style.position = "relative";
 }
}